import { Player } from './player';
import { Vec2 } from './vector';
import { Ball } from '@/game/ball';
import { uuid } from '@/game/uuid';
import { EventBus } from '@/event-bus';

export interface PlayerOptions {
  name: string;
  isBot: boolean;
  color: string;
  keys: {
    left: string;
    right: string;
  };
}
export interface GameOptions {
  players: PlayerOptions[];
  enablePowerups: boolean;
  enableBallSizeVariation: boolean;
  enableBallSpeedVariation: boolean;
  showTargets: boolean;
}

const DEFAULT_PL_WIDTH = 50;

export class Game {
  public players: Player[] = [];
  public balls: Ball[] = [];

  public width = 300;

  public isGame = false;
  public last: number = 0;
  public ballId = 0;

  public callbackFunction!: Function;

  constructor(options: GameOptions) {
    if (options) {
      if (options.players) {
        options.players.forEach(p => {
          const player = new Player(uuid(), DEFAULT_PL_WIDTH, p, this.width);
          this.players.push(player); // Add new player to players
        });
        this.updatePlayers();
      }
    }
  }

  public subscribe(cbk: Function) {
    this.callbackFunction = cbk;
  }

  public emit() {
    if (typeof this.callbackFunction === 'function') {
      this.callbackFunction(this.players, this.balls);
    }
  }

  // public addPlayer(name: string, color: string): Player { TODO
  //   // Every player gets a unique id (per server session)
  //   const player = new Player(uuid(), DEFAULT_PL_WIDTH, color, this.width);
  //   player.setUsername(name);
  //   this.players.push(player); // Add new player to players
  //   this.emit();

  //   if (this.isGame) this.updatePlayers();

  //   return player;
  // }

  public removePlayer(id: number) {
    if (this.players.length <= 3) {
      // Replace player with bot
      // TODO
    } else {
      // Remove player from players
      for (let i = 0; i < this.players.length; i++) {
        if (this.players[i].id == id) {
          this.players.splice(i, 1); // Remove player
          break;
        }
      }
      this.updatePlayers();
    }
  }

  public updatePlayers() {
    this.players.forEach((p, i) => {
      p.index = i; // Set index of players
      p.calcRotation(this.players.length);
    });
    this.emit();
  }

  public addBall() {
    setTimeout(() => {
      const ball = new Ball(this.ballId++);
      ball.calculateTarget(this.players);
      this.balls.push(ball);
      this.emit();
    }, 200);
  }

  // public addBot() { TODO
  //   const id = Math.floor(Math.random() * 9999);
  //   const player = new Player(uuid(), 50, color, this.width);
  //   player.setUsername('bot' + id);
  //   this.players.push(player);
  //   this.updatePlayers();
  // }

  public start() {
    if (!this.isGame) {
      // while (this.players.length < 3) { TODO
      //   // add bots until minimum of 3 players is reached
      //   this.addBot();
      // }

      this.isGame = true;
      this.ballId = 0; // Reset ball id
      this.addBall();
      // Send start to all
      // io.emit("start");

      // ui.game("started" + (player ? " by " + player : ""));

      // // Send the players again after start event
      // io.emit("players", players.map(p => p.getJSON()));

      this.emit();
      console.log('started game', this.balls);

      this.last = Date.now();
      this.run();
    }

  }

  /**
   * Returns all real players (excluding bots). 
   */
  public getPlayers() {
    return this.players.filter(p => !p.isBot);
  }

  public run() {
    if (this.isGame) {
      const now = Date.now();
      const dt = ((now - this.last) / 1000) || 0; // convert to seconds
      this.last = now;

      // console.log('fps=' + Math.round(1/dt));
      const fps = 'FPS=' + Math.round(1/dt).toString();
      const el = document.querySelector('.fps');
      if (el) { el.textContent = fps; }

      this.balls.forEach((ball) => {
        if (ball && ball.started) { ball.pos.add(ball.vel.clone().multiplyScalar(dt)); }
      });
      this.players.forEach((player) => {
        player.updatePosition(dt);
      });
      this.checkCollision();
      this.emit();

      // window.requestAnimationFrame(() => this.run());
      setTimeout(() => this.run(), 50);
    }
  }

  public stop() {
    // // Send stop to all
    // io.emit("stop");

    // // Remove bot players
    // players = players.filter(p => {
    //   return !p.isBot;
    // });

    // isGame = false;
    // balls = [];
    // ui.game("stopped");
    // ui.printBalls();
    // ui.printPlayers();

    this.isGame = false;
    this.balls = [];
  }

  public checkCollision() {
    for (let index = 0; index < this.balls.length; index++) {
      const ball = this.balls[index];
      if (ball && ball.started && ball.timestamp && ball.target) {
        const player = ball.target.player;
        const targetPos = ball.target.playerPos;

        if (!player) {
          // FIXME bug: Ball can escape playing field. For now, replace ball with a new one
          // FIXME ball can still escape playing field
          this.balls.splice(index, 1);
          index--;
          this.addBall();
          continue;
        }

        // Run bots
        if (player.isBot) {
          if (-targetPos > player.pos + 20) { player.setDirection('right'); }
          else if (-targetPos < player.pos - 20) { player.setDirection('left'); }
          else { player.setDirection('stop'); }
        }

        // Check collision
        const now = Date.now();
        if (now > ball.timestamp + ball.target.duration) {
          // Check if player at right position to hit the ball
          if (
            -targetPos > player.pos - player.width/2 - ball.radius/2 &&
            -targetPos < player.pos + player.width/2 + ball.radius/2
          ) {
            EventBus.$emit('hit', player);
            const angle = ball.vel.angle(player.tangent);
            ball.vel.rotate(angle * 2);
            ball.calculateTarget(this.players);
            ball.timestamp = Date.now();

            if (ball.effect) {
              // Apply effect
              player.applyEffect(ball.effect);
              ball.effect = undefined;
            }
          } else {
            if (ball.type === 'neutral') {
              EventBus.$emit('lost', player);

              // If player has more than 0 points, subtract one, otherwise every other player gets one point
              if (player.points > 0) {
                player.points--;
              } else {
                this.players.forEach((p) => {
                  if (p.id != player.id) { p.points++; }
                });
              }
            }

            // Remove ball
            this.balls.splice(index, 1);
            index--;
            this.addBall();
          }
        }

        // this.players.forEach(player => {
        //   let ballPos = ball.pos.clone();
        //   let playerPos = player.middlePoint.clone(); // -<Blockheight>
        //   let tangent = player.tangent.clone();
        //   let lambda =
        //     tangent.dot(ballPos.clone().sub(playerPos)) / tangent.dot(tangent);
        //   let foot = playerPos
        //     .clone()
        //     .add(tangent.clone().multiplyScalar(lambda));
        //   let blockMiddle = player.pos; // /<relBlockWidth>
        //   if (player.isBot && index === 0) { // only check first ball for now
        //     // overwrite positions of players?
        //     // player.setPosition(Math.floor(-lambda/(width-playerWidth)*width));
        //     let targetPos = Math.floor(
        //       (-lambda / (this.width - player.width)) * this.width
        //     );
        //     if (targetPos < player.pos) player.setDirection("left");
        //     else if (targetPos > player.pos) player.setDirection("right");
        //     else player.setDirection("stop");
        //     // ui.playerPos(player.pos, player.index);
        //   }
        //   if (foot.distance(ballPos) < ball.radius/2 + 3) { // player is 6px thick
        //     // console.log(player.pos,blockMiddle, lambda);
        //     if (
        //       -lambda < blockMiddle + 0.5 * player.width + ball.radius / 2 &&
        //       -lambda > blockMiddle - 0.5 * player.width - ball.radius / 2
        //     ) {
        //       // +- Tolerance
        //       // ui.game(player.name + " hit the ball");
        //       console.log(player.name + ' hit the ball');
        //       let angleMod =
        //         (15 * Math.PI * ((blockMiddle + lambda) / (this.width / 10))) / 180;
        //       let angle = ball.vel.angle(tangent);
        //       ball.vel.rotate(angle * 2 - angleMod);
        //       this.calculateTarget(ball);
        //     } else {
        //       // ui.game(player.name + " lost");
        //       console.log(player.name + " lost");
        //       // If player has more than 0 points, subtract one, otherwise every other player gets one point
        //       if (player.points > 0) player.points--;
        //       else
        //         this.players.forEach(p => {
        //           if (p.id != player.id) p.points++;
        //         });
        //       // Remove ball
        //       this.balls.splice(index, 1);
        //       index--;
        //       this.addBall();

        //       // io.emit("players", players.map(p => p.getJSON())); // To update score
        //       // ui.printBalls(balls);
        //       // ui.printPlayers(players);
        //     }
        //     // emitBallPositions();
        //   }
        // });
      }
    }
  }

}

/*
 ___
| _ \___ _ _  __ _
|  _/ _ \ ' \/ _` |
|_| \___/_||_\__, |
             |___/ */
